/**
 * Firebase Optimization Utilities
 * Optimizes Firebase configuration for better performance
 */

/**
 * Configure Firebase for production or development
 * Note: enableNetwork/disableNetwork are not called here as they can cause issues
 * if called before Firebase is fully initialized. Firebase is enabled by default.
 */
export function configureFirebaseOptimization(): void {
  // Only run in browser environment
  if (typeof window === 'undefined') {
    return;
  }

  // Firebase optimizations that don't require immediate network access
  // Network is enabled by default in Firebase, so we don't need to explicitly enable it
  
  if (process.env.NODE_ENV === 'production') {
    // Production-specific optimizations can be added here
    // Silent in production
  } else {
    // Development-specific optimizations can be added here
    // Silent in development for cleaner console
  }
}

// Auto-configure on import (but delay slightly to ensure Firebase is initialized)
if (typeof window !== 'undefined') {
  // Use setTimeout to ensure Firebase is fully initialized
  setTimeout(() => {
    configureFirebaseOptimization();
  }, 100);
}
